import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Typography,
  Paper,
  Grid,
  Alert,
} from "@mui/material";
import {
  UploadHomeBanners,
  GetHomeBanners,
  DeleteHomeBanner,
} from "../../utils/homeBanner";

export default function AdminHomeBanners() {
  const [image1, setImage1] = useState(null);
  const [image2, setImage2] = useState(null);
  const [preview1, setPreview1] = useState("");
  const [preview2, setPreview2] = useState("");
  const [currentBanners, setCurrentBanners] = useState([]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const loadBanners = async () => {
    const data = await GetHomeBanners();
    setCurrentBanners(data);
  };

  useEffect(() => {
    loadBanners();
  }, []);

  const handleImage1Change = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImage1(file);
    setPreview1(URL.createObjectURL(file));
    setMessage("");
    setError("");
  };

  const handleImage2Change = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImage2(file);
    setPreview2(URL.createObjectURL(file));
    setMessage("");
    setError("");
  };

  const handleSave = async () => {
    try {
      if (!image1 || !image2) {
        setError("חובה לבחור שתי תמונות");
        return;
      }

      await UploadHomeBanners([image1, image2]);

      setMessage("התמונות הראשיות עודכנו בהצלחה");
      setError("");
      setImage1(null);
      setImage2(null);
      setPreview1("");
      setPreview2("");

      await loadBanners();
    } catch (err) {
      console.error(err);
      setError("אירעה שגיאה בהעלאת התמונות");
      setMessage("");
    }
  };

  const handleDelete = async (id) => {
    try {
      await DeleteHomeBanner(id);
      setMessage("התמונה נמחקה בהצלחה");
      setError("");
      await loadBanners();
    } catch (err) {
      console.error(err);
      setError("אירעה שגיאה במחיקת התמונה");
      setMessage("");
    }
  };

  return (
    <Box sx={{ direction: "rtl", p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>
        ניהול תמונות ראשיות בדף הבית
      </Typography>

      {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

      <Paper sx={{ p: 3, maxWidth: 1000, mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          התמונות הפעילות כרגע
        </Typography>

        <Grid container spacing={3}>
          {currentBanners.length === 0 && (
            <Grid item xs={12}>
              <Typography>אין כרגע תמונות פעילות.</Typography>
            </Grid>
          )}

          {currentBanners.map((banner) => (
            <Grid item xs={12} md={6} key={banner.id}>
              <Box
                sx={{
                  position: "relative",
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  overflow: "hidden",
                }}
              >
                <Box
                  component="img"
                  src={banner.image}
                  alt="תמונה ראשית"
                  sx={{
                    width: "100%",
                    height: 250,
                    objectFit: "cover",
                    display: "block",
                  }}
                />

                <Button
                  variant="contained"
                  color="error"
                  onClick={() => handleDelete(banner.id)}
                  sx={{
                    position: "absolute",
                    top: 10,
                    left: 10,
                    minWidth: 40,
                  }}
                >
                  ✕
                </Button>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Paper>

      <Paper sx={{ p: 3, maxWidth: 1000 }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          העלאת שתי תמונות חדשות
        </Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Button variant="contained" component="label">
              בחירת תמונה ראשונה
              <input type="file" hidden accept="image/*" onChange={handleImage1Change} />
            </Button>

            {preview1 && (
              <Box
                component="img"
                src={preview1}
                alt="תמונה ראשונה"
                sx={{
                  width: "100%",
                  height: 250,
                  objectFit: "cover",
                  borderRadius: 2,
                  border: "1px solid #ddd",
                  mt: 2,
                }}
              />
            )}
          </Grid>

          <Grid item xs={12} md={6}>
            <Button variant="contained" component="label">
              בחירת תמונה שנייה
              <input type="file" hidden accept="image/*" onChange={handleImage2Change} />
            </Button>

            {preview2 && (
              <Box
                component="img"
                src={preview2}
                alt="תמונה שנייה"
                sx={{
                  width: "100%",
                  height: 250,
                  objectFit: "cover",
                  borderRadius: 2,
                  border: "1px solid #ddd",
                  mt: 2,
                }}
              />
            )}
          </Grid>
        </Grid>

        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            color="success"
            onClick={handleSave}
            disabled={!image1 || !image2}
          >
            שמירת התמונות
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}